"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFixMarks = void 0;
var translate2d_1 = require("../../common/translate2d");
var toStepArray = function (max, step) {
    var arr = [];
    for (var i = max; i >= 0; i -= step) {
        arr.push(i);
    }
    return arr;
};
exports.getFixMarks = function (srcPlane, destPlane, fixMax, fixStep) {
    var steps = toStepArray(fixMax, Math.ceil(fixMax / fixStep));
    var markers = steps.map(function (it) {
        return [
            it,
            Math.floor(translate2d_1.translate2d([0, it], srcPlane, destPlane)[1])
        ];
    });
    return markers;
};
